import React from "react";
import ModalBody from "./modal-body";
// import logo from "../assets/img/LogoLubrizol_Small.png";

export default function Modal() {
  return (
    <div>
      <span
        className="btn-modal"
        data-target="#exampleModal"
      >
        <spam classname="farsi-text">      نموداری مقایسه استانداردهای روغن های دنده </spam>
      </span>

      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-header1" id="exampleModalLabel">
                {" "}
                موارد مقایسه ایی نمودار
              </h6>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span className="Closetype" aria-hidden="true">
                  &times;
                </span>
              </button>
            </div>
            <div className="modal-body">
              <ModalBody />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
